var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 16.5a7.5 7.5 0 100-15 7.5 7.5 0 000 15z",
    fill: "#C4C9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.167 9.5A6.667 6.667 0 008.5 2.833V9.5h6.667z",
    fill: "#fff"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkgMTYuNUMxMy4xNDIxIDE2LjUgMTYuNSAxMy4xNDIxIDE2LjUgOUMxNi41IDQuODU3ODYgMTMuMTQyMSAxLjUgOSAxLjVDNC44NTc4NiAxLjUgMS41IDQuODU3ODYgMS41IDlDMS41IDEzLjE0MjEgNC44NTc4NiAxNi41IDkgMTYuNVoiIGZpbGw9IiNDNEM5RDkiLz4KPHBhdGggZD0iTTE1LjE2NjcgOS40OTk2N0MxNS4xNjY3IDguNjI0MiAxNC45OTQyIDcuNzU3MjkgMTQuNjU5MiA2Ljk0ODQ1QzE0LjMyNDIgNi4xMzk2MSAxMy44MzMxIDUuNDA0NjkgMTMuMjE0IDQuNzg1NjNDMTIuNTk1IDQuMTY2NTcgMTEuODYwMSAzLjY3NTUxIDExLjA1MTIgMy4zNDA0OEMxMC4yNDI0IDMuMDA1NDUgOS4zNzU0OCAyLjgzMzAxIDguNSAyLjgzMzAxVjkuNDk5NjdIMTUuMTY2N1oiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgPieChart as ReactComponent };